import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-238" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-239" data-mp="j7ydcyfs06zq">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-240" data-mp="j53tb80oco6u">
          Everything included:
        </h2>
        <p className="mt-3 text-center text-muted" data-id="element-241" data-mp="1bvkrv1qjkw1d">
          {productShortName} · {totalVolumes} volumes + {totalBonuses} bonuses ·{' '}
          <b className="text-mineral" data-id="element-242" data-mp="16uy47k1fo2og">{price}</b>
        </p>

        <ul className="mt-10 grid overflow-hidden rounded-xl border border-gold/40 bg-steel sm:grid-cols-2" data-id="element-243" data-mp="12vxpodpznm79">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 border-b border-white/10 p-4 sm:odd:border-r" data-id="element-244" data-mp="3rknkm1hsbwj9">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-mineral" data-id="element-245" data-mp="3nnrdhn3g6x73">
                <CheckIcon className="h-3.5 w-3.5 text-navy" aria-hidden="true" data-id="element-246" data-mp="3nbqvtqdydf2o" />
              </span>
              <p data-id="element-247" data-mp="39chqxmv767e0">
                <b className="block text-sm text-white" data-id="element-248" data-mp="39czl8dyaubja">{feature}</b>
                <span className="text-sm text-muted" data-id="element-249" data-mp="3ddt957bqrqc6">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-gold bg-steel px-6 py-5 text-center text-lg font-bold leading-relaxed text-white" data-id="element-250" data-mp="2zm4xt69bh5w9">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}